import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { MergeField } from '../../decorators/decorators/merge.field';
import { MergeSchema } from '../../decorators/decorators/merge.schema';
import { getSchema } from '../../decorators/utilities/get.merge.schema';
import { JobItemMergeData } from './job.item.merge.data';

@MergeSchema({
    entity: ActivityEntityName.Job,
})
export class JobIncludeItemsMergeData {
    @MergeField({
        arraySchemaName: 'JobItemMergeDataSchema',
    })
    items: JobItemMergeData[] = [];

    @MergeField()
    itemCount: number;

    @MergeField()
    totalBuyExTax: number;

    @MergeField()
    totalSellExTax: number;
}

export const JobIncludeItemsMergeDataSchema = getSchema(JobIncludeItemsMergeData)